/** The sign-in scene is an illustration of the territory, not an operational map: its centre
 *  and scale are fixed (lowland of Lombardy) and shown only because every Sentinel map carries
 *  them (rule 21). Real positions appear in the Control Center, never here. */
export const SCENE_CENTER = { lng: 9.3306, lat: 45.4019 };
export const SCENE_SCALE_KM = 2;

/** Health of the sign-in service, polled while the page is open. */
export const HEALTH_URL = '/health/live';
export const HEALTH_POLL_MS = 30_000;
